import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PossessionTaskStatus } from 'src/app/dto';

@Component({
    selector: 'app-possession-task',
    templateUrl: './possession-task.component.html',
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PossessionTaskComponent {
    @Input() task: PossessionTaskStatus;
}
